










import { Component, Vue } from "vue-property-decorator";
import Menu from "./components/Menu.vue";
import Footer from "./components/Footer.vue";

@Component({
  components: {
    "app-menu": Menu,
    "app-footer": Footer
  }
})
export default class App extends Vue {
  get loggedIn() {
    return this.$store.state.loggedIn;
  }
}
